import { useState } from 'react';
import { useIntl } from 'react-intl';
import Popover from '@mui/material/Popover';
import { useInfo } from '../../infocontext/InfoContext';
import './withInfo.css';

const WithInfo = ({ translationKey, children, topOffset = '-12px', rightOffset = '-25px', iconStyle = { paddingTop: '1px', paddingLeft: '1px' }, wrapperStyle, touchTargetStyle, inline = false }) => {
  const { infoKeys = [] } = useInfo() || {};
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);

  const shouldShowInfo = typeof translationKey === 'string' && infoKeys.some((key) => key === translationKey || key.endsWith(translationKey));

  if (!shouldShowInfo) {
    return children;
  }

  const handleIconClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);
  const translatedMessage = intl.messages[translationKey] || translationKey;
  const computedTouchTargetStyle = inline ? { position: 'relative', width: 'auto', height: 'auto', marginLeft: '6px' } : { top: topOffset, right: rightOffset };

  return (
    <div className="info-wrapper" style={wrapperStyle}>
      {children}

      <div className="info-touch-target" onClick={handleIconClick} style={{ ...computedTouchTargetStyle, ...touchTargetStyle }}>
        <div className="info-icon" style={iconStyle}>
          ?
        </div>
      </div>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        disableRestoreFocus
        slotProps={{
          paper: {
            className: 'info-popover-content'
          }
        }}>
        <div className="info-popover-text">{translatedMessage}</div>
        <button className="info-popover-close-btn" onClick={handleClose}>
          &times;
        </button>
      </Popover>
    </div>
  );
};

export default WithInfo;
